import d from '../FetchDesign.module.css';

export function FetchTrustpilot({ centered }: { centered?: boolean }) {
  return (
    <span
      className={d.trustpilot}
      data-centered={centered ? 'true' : 'false'}
      role="img"
      aria-label="Rated Excellent on Trustpilot"
    />
  );
}
